import React from 'react';

const BuildingIcon = (props) => {
  return (
    <img
      alt="Zabytek"
      src="/static/images/icons/tourist_attractions/building.svg"
      {...props}
    />
  );
};

export default BuildingIcon;
